














import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class DaySelector extends Vue {
  @Prop() private _designatedDate!: string

  get designatedDate(): string {
      return this._designatedDate;
  }

  set designatedDate(value: string) {
      this.$emit("change", value);
  }

  private designatedDateList = {
    '1日': '01',
    '2日': '02',
    '3日': '03',
    '4日': '04',
    '5日': '05',
    '6日': '06',
    '7日': '07',
    '8日': '08',
    '9日': '09',
    '10日': '10',
    '11日': '11',
    '12日': '12',
    '13日': '13',
    '14日': '14',
    '15日': '15',
    '16日': '16',
    '17日': '17',
    '18日': '18',
    '19日': '19',
    '20日': '20',
    '21日': '21',
    '22日': '22',
    '23日': '23',
    '24日': '24',
    '25日': '25',
    '26日': '26',
    '27日': '27',
    '28日': '28',
    '29日': '29',
    '30日': '30',
    '31日': '31',
  }
}
